// @flow

import MemberUtils from 'web-core/src/utils/member';
import {
  type ConditionsType,
  MEMBER_APPLICATION_TYPES,
  MEMBER_TYPES,
} from 'client/constants/health';

type SessionMemberApplicationParams = {
  ifp_app_id?: number | void,
  member_id: string,
  type: string,
};

type SessionMemberParams = {
  age?: null | number,
  dob?: null | string,
  gender?: null | string,
  id?: string,
  illnesses?: Array<ConditionsType>,
  member_application?: SessionMemberApplicationParams,
  status?: string,
  tobacco?: boolean,
  type: string,
};

export type SessionMemberType = {
  age: null | number,
  dob: null | string,
  first_name: string,
  gender: null | string,
  id: string,
  illnesses: Array<ConditionsType>,
  last_name: string,
  member_application: SessionMemberApplicationParams,
  middle_name: string,
  status: string,
  tobacco: boolean,
  type: string,
  visits: Array<string>,
};

export class Session_Member_Application {
  ifp_app_id: number | void;
  member_id: string;
  type: string;

  constructor({
    ifp_app_id = 0,
    member_id,
    type = MEMBER_APPLICATION_TYPES.COVERAGE,
  }: SessionMemberApplicationParams) {
    this.ifp_app_id = ifp_app_id;
    this.member_id = member_id;
    this.type = type;
  }
}

export class Session_Member {
  age: null | number;
  dob: null | string;
  first_name: string;
  gender: null | string;
  id: string;
  illnesses: Array<ConditionsType>;
  last_name: string;
  member_application: SessionMemberApplicationParams;
  middle_name: string;
  status: string;
  tobacco: boolean;
  type: string;
  visits: Array<string>;

  constructor({
    // $FlowFixMe https://github.com/facebook/flow/issues/183#issuecomment-358607052
    age = null,
    // $FlowFixMe https://github.com/facebook/flow/issues/183#issuecomment-358607052
    dob = null,
    // $FlowFixMe https://github.com/facebook/flow/issues/183#issuecomment-358607052
    gender = null,
    id = MemberUtils.uuid(),
    illnesses = [],
    status = MEMBER_APPLICATION_TYPES.COVERAGE,
    tobacco,
    type = MEMBER_TYPES.PRIMARY,
  }: SessionMemberParams) {
    this.age = age;
    this.dob = dob;
    this.first_name = '';
    this.gender = gender;
    this.id = id;
    this.illnesses = illnesses;
    this.last_name = '';
    this.member_application = new Session_Member_Application({ member_id: id, type: status });
    this.middle_name = '';
    this.status = status;
    this.tobacco = tobacco;
    this.type = type;
    this.visits = [];
  }
}
